<template>
  <div>
    <ErrorsAlert :errors="errors" />

    <form role="form" @submit.prevent="onSubmit">
      <vs-tabs alignment="fixed" v-model="activeTab">
        <vs-tab label="Empresa" data-testId="tab-company-data">
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/3 w-full mb-3">
              <span>Razão Social</span>
              <vs-input
                size="large"
                class="w-full"
                name="Razao Social"
                id="Razao Social"
                v-model="formCadastro.razaoSocial"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Razao Social')"
                :danger="validateClass('Razao Social')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="social-name-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Nome Fantasia</span>
              <vs-input
                size="large"
                class="w-full"
                name="Nome Fantasia"
                id="Nome Fantasia"
                v-model="formCadastro.nome"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Nome Fantasia')"
                :danger="validateClass('Nome Fantasia')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="fantasy-name-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>CNPJ</span>
              <vs-input
                size="large"
                class="w-full"
                name="CNPJ"
                id="CNPJ"
                v-model="formCadastro.cnpj"
                v-validate="{ required: true, length: 18 }"
                :state="validateState('CNPJ')"
                :danger="validateClass('CNPJ')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="DOCUMENT_MASK.CNPJ"
                @input="formCadastro.cnpj = $event.toUpperCase()"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="cpf-cnpj-input"
              />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Email</span>
              <vs-input
                size="large"
                class="w-full"
                name="Email"
                id="Email"
                v-model="formCadastro.email"
                v-validate="{ required: true, email: true }"
                :state="validateState('Email')"
                :danger="validateClass('Email')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="email-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Central de Atendimento</span>
              <vs-input
                size="large"
                class="w-full"
                name="Telefone"
                id="Telefone"
                v-model="formCadastro.telefone"
                v-validate="{ required: true }"
                :state="validateState('Telefone')"
                :danger="validateClass('Telefone')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="central-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Telefone da Assistência</span>
              <vs-input
                size="large"
                class="w-full"
                name="Telefone da Assistência"
                id="Telefone da Assistência"
                v-model="formCadastro.telefoneAssistencia"
                v-validate="{ required: true }"
                :state="validateState('Telefone da Assistência')"
                :danger="validateClass('Telefone da Assistência')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                data-testId="assistence-input"
              />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>CEP</span>
              <vs-input
                size="large"
                class="w-full"
                name="Cep"
                id="Cep"
                @keyup.native="keymonitor"
                v-model="formCadastro.cep"
                v-validate="{ required: true, min: 10 }"
                :state="validateState('Cep')"
                :danger="validateClass('Cep')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'##.###-###'"
                data-testId="cep-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Número</span>
              <vs-input
                size="large"
                class="w-full"
                name="Numero"
                id="Numero"
                v-model="formCadastro.numero"
                v-validate="{ required: true }"
                :state="validateState('Numero')"
                :danger="validateClass('Numero')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                data-testId="number-input"
              />
            </div>
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <span>Complemento</span>
              <vs-input
                size="large"
                class="w-full"
                name="Complemento"
                id="Complemento"
                v-model="formCadastro.complemento"
                :state="validateState('Complemento')"
                :danger="validateClass('Complemento')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                data-testId="complement-input"
              />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Endereço</span>
              <vs-input
                size="large"
                class="w-full"
                name="Endereço"
                id="Endereço"
                v-model="formCadastro.endereco"
                v-validate="{ required: true, min: 6 }"
                :state="validateState('Endereço')"
                :danger="validateClass('Endereço')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                data-testId="address-input"
              />
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Bairro</span>
              <vs-input
                size="large"
                class="w-full"
                name="Bairro"
                id="Bairro"
                v-model="formCadastro.bairro"
                v-validate="{ required: true }"
                :state="validateState('Bairro')"
                :danger="validateClass('Bairro')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
                data-testId="neighborhood-input"
              />
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Cidade</span>
              <vs-input
                size="large"
                class="w-full"
                name="Cidade"
                id="Cidade"
                v-model="formCadastro.cidade"
                v-validate="{ required: true }"
                :state="validateState('Cidade')"
                :danger="validateClass('Cidade')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
                data-testId="city-input"
              />
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Estado</span>
              <vs-input
                size="large"
                class="w-full"
                name="Estado"
                id="Estado"
                v-model="formCadastro.estado"
                v-validate="{ required: true, min: 2, max: 2 }"
                :state="validateState('Estado')"
                :danger="validateClass('Estado')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                icon-pack="feather"
                icon
                icon-no-border
                data-testId="state-input"
              />
            </div>
          </div>
          <div class="vx-row mb-4 mt-3 img">
            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Logo</h4>
              <center>
                <img
                  :src="formCadastro.logo"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload"
                type="file"
                hidden
                v-on:change="selecionaLogo"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click="chooseFiles()"
                data-testId="logo-input"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="nomeLogo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeLogo }}</span>
                </vs-chip>
              </vs-button>
            </div>

            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Capa Boleto</h4>
              <center>
                <img
                  :src="formCadastro.capaBoleto"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload3"
                type="file"
                hidden
                v-on:change="selecionaCapaBoleto"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop="chooseFiles3()"
                v-if="$can('Logo', subjectPermission)"
                data-testId="cover-bill-input"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="nomeLogo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeLogo }}</span>
                </vs-chip>
              </vs-button>
            </div>
          </div>

          <div class="vx-row mb-4 mt-3 img">
            <div
              class="vx-col containerimg sm:w-1/2 w-full mb-2 text-center mt-4"
            >
              <h4 class="mb-3">Imagem no Login</h4>
              <center>
                <img
                  :src="formCadastro.imagemLogin"
                  width="100%"
                  style="max-width: 250px"
                />
              </center>
              <input
                id="fileUpload4"
                type="file"
                hidden
                v-on:change="selecionaImagemLogin"
              />
              <vs-button
                color="warning"
                type="border"
                class="mr-3 mt-2 text-center"
                @click.stop="chooseFiles4()"
                data-testId="login-image-input"
              >
                Escolher uma Imagem
                <feather-icon icon="UploadIcon" class="ml-2" />
                <Br />
                <vs-chip v-if="nomeLogo" class="mt-3">
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeLogo }}</span>
                </vs-chip>
              </vs-button>
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Configurações" data-testId="configurations-tab">
          <vs-col vs-justify="center" vs-align="center" vs-w="6">
            <div class="vx-row">
              <div class="vx-col mb-6">
                <label>Dias de Vencimento</label>
                <v-select
                  :options="diasVencimento"
                  name="Dias de Vencimento"
                  id="Dias de Vencimento"
                  multiple
                  v-model="formCadastro.diasVencimento"
                  v-validate="{ required: true }"
                  :state="validateState('Dias de Vencimento')"
                  :class="validateClass('Dias de Vencimento')"
                  :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                  :data-testId="`dias-vencimento-select`"
                ></v-select>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permitir acesso as fotos da galeria na vistoria?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.habilitarFotoGaleria"
                  style="width: 60px"
                  data-testId="gallery-switch"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <span>Email de backup</span>
                <vs-input
                  size="large"
                  class="w-full"
                  name="Email de backup"
                  id="Email de backup"
                  v-model="formCadastro.backupEmail"
                  v-validate="{ required: true }"
                  :state="validateState('Email de backup')"
                  :danger="validateClass('Email de backup')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <span>Quantidade de Dias para Vencimento à Vista</span>
                <vs-input
                  size="large"
                  class="w-full"
                  name="Dias para Vencimento"
                  id="Dias para Vencimento"
                  v-model="formCadastro.qtdDiasVencimentoAvista"
                  v-validate="{ required: true }"
                  :state="validateState('Dias para Vencimento')"
                  :danger="validateClass('Dias para Vencimento')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  data-testId="installments-days-input"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <span>Quantidade de Dias Expiração Boleto/PIX</span>
                <vs-input
                  size="large"
                  class="w-full"
                  name="Dias Expiração"
                  id="Dias Expiração"
                  v-model="formCadastro.qtdDiasNaoPagamento"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Expiração')"
                  :danger="validateClass('Dias Expiração')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  data-testId="pix-days-input"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <span
                  >Dias após vencimento do boleto para notificar
                  inadimplência</span
                >
                <vs-input
                  size="large"
                  class="w-full"
                  name="Dias Notificação inadimplência"
                  id="Dias Notificação inadimplência"
                  v-model="
                    formCadastro.qtdDiasEnviarNotificacaoInadimplenciaBoleto
                  "
                  type="number"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Notificação inadimplência')"
                  :danger="validateClass('Dias Notificação inadimplência')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  data-testId="notify-days-input"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <span>Quantidade de Dias Expiração da Proposta</span>
                <vs-input
                  size="large"
                  class="w-full"
                  name="Dias Expiração"
                  id="Dias Expiração"
                  v-model="formCadastro.qtdDiasVencimentoProposta"
                  v-validate="{ required: true }"
                  :state="validateState('Dias Expiração')"
                  :danger="validateClass('Dias Expiração')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  data-testId="proposal-days-input"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-3/4 mb-6">
                <label for="Retentativas de envio de mensageria">
                  Quantidade de retentativas de envio de mensageria
                </label>
                <vs-input
                  size="large"
                  class="w-full"
                  name="Retentativas de envio de mensageria"
                  id="Retentativas de envio de mensageria"
                  v-model="formCadastro.messagingMaxRetries"
                  v-validate="{ required: true }"
                  :state="validateState('Retentativas de envio de mensageria')"
                  :danger="validateClass('Retentativas de envio de mensageria')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  icon-no-border
                  data-testId="messaging-retries-input"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-6">
                <span>Permitir criar várias cotações por placa?</span>
                <vs-switch
                  color="success"
                  v-model="formCadastro.permiteVariasCotacoesPorPlaca"
                  style="width: 60px"
                  data-testId="installments-plate-switch"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
            </div>
          </vs-col>
        </vs-tab>

        <vs-tab label="Seguradora">
          <div class="vx-row mb-4 mt-3">
            <div class="vx-col w-full mb-2">
              <CarregamentosForm
                :formData="formCadastro"
                parent="2"
                :mostraTotal="true"
              />
            </div>
          </div>

          <div class="vx-row mb-4 mt-24">
            <div class="vx-col w-full mb-2">
              <h6 class="">Comissão Auto</h6>
            </div>
            <vs-row>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% Máximo da Parcela"
                  name="percentual maximo parcela"
                  id="percentual maximo parcela"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoPercentualMaximoParcela"
                  :state="validateState('percentual maximo parcela')"
                  :danger="validateClass('percentual maximo parcela')"
                ></vs-input>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% IRRF"
                  name="aliquota IRRF"
                  id="aliquota IRRF"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaIrrf"
                  :state="validateState('aliquota IRRF')"
                  :danger="validateClass('aliquota IRRF')"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% INSS"
                  name="aliquota INSS"
                  id="aliquota INSS"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaInss"
                  :state="validateState('aliquota INSS')"
                  :danger="validateClass('aliquota INSS')"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% ISS"
                  name="aliquota ISS"
                  id="aliquota ISS"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaIss"
                  :state="validateState('aliquota ISS')"
                  :danger="validateClass('aliquota ISS')"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% PIS"
                  name="aliquota PIS"
                  id="aliquota PIS"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaPis"
                  :state="validateState('aliquota PIS')"
                  :danger="validateClass('aliquota PIS')"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% COFINS"
                  name="aliquota cofins"
                  id="aliquota cofins"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaCofins"
                  :state="validateState('aliquota cofins')"
                  :danger="validateClass('aliquota cofins')"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% CSLL"
                  name="aliquota CSLL"
                  id="aliquota CSLL"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.comissaoAliquotaCsll"
                  :state="validateState('aliquota CSLL')"
                  :danger="validateClass('aliquota CSLL')"
                ></vs-input>
              </vs-col>
            </vs-row>
          </div>
        </vs-tab>

        <vs-tab label="Conta Corrente" data-testId="tab-account">
          <div>
            <vs-row>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <label for="" class="vs-input--label"
                  >R$ Máximo Por Cotação</label
                >
                <money
                  class="w-full vs-inputx vs-input--input normal"
                  name="valor máximo por cotação"
                  id="valor máximo por cotação"
                  v-model="formCadastro.contaCorrenteValorMaximoCotacao"
                  v-validate="{ required: true, min_value: 0 }"
                  v-bind="money"
                  :state="validateState('valor máximo por cotação')"
                  :danger="validateClass('valor máximo por cotação')"
                  data-testId="max-discount-input"
                ></money>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% Máximo Do Desconto"
                  name="percentual máximo do desconto"
                  id="percentual máximo do desconto"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.contaCorrentePercentualMaximoDesconto"
                  :state="validateState('percentual máximo do desconto')"
                  :danger="validateClass('percentual máximo do desconto')"
                  data-testId="max-discount-percentage-input"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% Máximo De Corretagem"
                  name="percentual máximo de corretagem"
                  id="percentual máximo de corretagem"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="formCadastro.contaCorrentePercentualMaximoCorretagem"
                  :state="validateState('percentual máximo de corretagem')"
                  :danger="validateClass('percentual máximo de corretagem')"
                  data-testId="max-margin-percentage-input"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <label for="" class="vs-input--label">R$ Máximo Mensal</label>
                <money
                  class="w-full vs-inputx vs-input--input normal"
                  name="valor máximo mensal"
                  id="valor máximo mensal"
                  v-model="formCadastro.contaCorrenteValorMaximoMensal"
                  v-validate="{ required: true, min_value: 0 }"
                  v-bind="money"
                  :state="validateState('valor máximo mensal')"
                  :danger="validateClass('valor máximo mensal')"
                  data-testId="max-monthly-input"
                ></money>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <label for="" class="vs-input--label"
                  >R$ Máximo Por Cotação - BP</label
                >
                <money
                  class="w-full vs-inputx vs-input--input normal"
                  name="valor máximo por cotação renovação"
                  id="valor máximo por cotação renovação"
                  v-model="formCadastro.bpRenewalMaxDiscountValue"
                  v-validate="{ required: true, min_value: 0 }"
                  v-bind="money"
                  :state="validateState('valor máximo por cotação renovação')"
                  :danger="validateClass('valor máximo por cotação renovação')"
                  data-testId="max-discount-renewal-input"
                ></money>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% Máximo Do Desconto - BP"
                  name="percentual máximo do desconto renovação"
                  id="percentual máximo do desconto renovação"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="
                    formCadastro.bpRenewalMaxDiscountPercentage
                  "
                  :state="validateState('percentual máximo do desconto renovação')"
                  :danger="validateClass('percentual máximo do desconto renovação')"
                  data-testId="max-discount-percentage-renewal-input"
                ></vs-input>
              </vs-col>
              <vs-col class="mb-3" vs-xs="12" vs-sm="6" vs-lg="3">
                <vs-input
                  label="% Máximo De Corretagem - BP"
                  name="percentual máximo de corretagem renovação"
                  id="percentual máximo de corretagem renovação"
                  icon-pack="feather"
                  icon="icon-percent"
                  class="w-full"
                  type="number"
                  step="0.1"
                  :max="100"
                  :min="0"
                  v-validate="'required|between:0,100'"
                  v-model="
                    formCadastro.bpRenewalMaxBrokeragePercentage
                  "
                  :state="validateState('percentual máximo de corretagem renovação')"
                  :danger="validateClass('percentual máximo de corretagem renovação')"
                  data-testId="max-margin-percentage-renewal-input"
                ></vs-input>
              </vs-col>
            </vs-row>
          </div>
        </vs-tab>

        <vs-tab label="Rotinas" data-testId="tab-routines">
          <Routines :subjectPermission="subjectPermission" />
        </vs-tab>

        <vs-tab
          v-if="haveSystemNoticePermission"
          label="Aviso do sistema"
          data-testId="tab-system-notice"
        >
          <FormSystemNotice
            ref="formSystemNotice"
            :systemNoticeProp="systemNoticeObject()"
            @update="handleUpdateSystemNotice"
          />
        </vs-tab>
      </vs-tabs>

      <div class="vx-row" v-if="activeTabLabels[activeTab] !== 'routines'">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            data-testId="cancel-button"
            >Cancelar
          </vs-button>

          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
            data-testId="save-button"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
import BotaoSubmit from './../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
import CarregamentosForm from '../menu/nova-cotacao-seguradora/components/carregamentosForm';
import ErrorsAlert from './../../components/ErrorsAlert.vue';
import Routines from './Routines.vue';
import FormSystemNotice from './FormSystemNotice.vue';

import vSelect from 'vue-select';
import { Money } from 'v-money';
import notify from '../../utils/notify';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: ['subjectPermission'],
  watch: {},
  data() {
    return {
      DOCUMENT_MASK,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      fotoAtual: 0,
      currentPage: 1,
      pageCount: 0,
      hasImage: false,
      files: new FormData(),
      image: null,
      languages: lang,
      nomeLogo: null,
      capaBoleto: null,
      funcoesValicao: null,
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      formCadastro: {
        idEmpresa: null,
        nome: '',
        email: '',
        cnpj: '',
        telefone: '',
        telefoneAssistencia: '',
        logo: '',
        diasVencimento: [],
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        razaoSocial: '',
        capaBoleto: null,
        imagemLogin: null,
        habilitarFotoGaleria: null,
        qtdDiasVencimentoAvista: '',
        qtdDiasNaoPagamento: '',
        qtdDiasEnviarNotificacaoInadimplenciaBoleto: null,
        permiteVariasCotacoesPorPlaca: null,
        qtdDiasVencimentoProposta: null,
        messagingMaxRetries: null,
        backupEmail: null,
        contaCorrenteValorMaximoCotacao: 0,
        contaCorrentePercentualMaximoDesconto: 0,
        contaCorrentePercentualMaximoCorretagem: 0,
        bpRenewalMaxDiscountValue: 0,
        bpRenewalMaxDiscountPercentage: 0,
        bpRenewalMaxBrokeragePercentage: 0,
        comissaoPercentualMaximoParcela: 0,
        comissaoAliquotaIrrf: 0,
        comissaoAliquotaInss: 0,
        comissaoAliquotaIss: 0,
        comissaoAliquotaPis: 0,
        comissaoAliquotaCofins: 0,
        comissaoAliquotaCsll: 0,
        contaCorrenteValorMaximoMensal: 0,
        carregamentos: {
          'Despesa ADM': { porcentagem: 0 },
          'Margem de Lucro': { porcentagem: 0 },
          Repasse: { porcentagem: 0 },
          Estipulante: { porcentagem: 0 },
        },
        systemNotice: {},
      },
      activeTab: 0,
      activeTabLabels: [
        'data',
        'configs',
        'congener',
        'current_account',
        'routines',
      ],
    };
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    haveSystemNoticePermission() {
      return this.$can('Aviso do Sistema', this.subjectPermission);
    },
  },
  methods: {
    selecionaLogo(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.nomeLogo = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload('Upload', 'logo/' + this.formCadastro.idEmpresa, this.files)
        .then((response) => {
          this.formCadastro.logo = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    selecionaCapaBoleto(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.capaBoleto = event.target.files[0].name;
      this.$vs.loading();
      service
        .upload(
          'Upload',
          'capaBoleto/' + this.formCadastro.idEmpresa,
          this.files,
        )
        .then((response) => {
          this.formCadastro.capaBoleto = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    selecionaImagemLogin(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.imagemLogin = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload(
          'Upload',
          'imagemLogin/' + this.formCadastro.idEmpresa,
          this.files,
        )
        .then((response) => {
          this.formCadastro.imagemLogin = response;
          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      });
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    chooseFiles3() {
      document.getElementById('fileUpload3').click();
    },
    chooseFiles4() {
      document.getElementById('fileUpload4').click();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosCadastro() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;

          service
            .getAll(
              'g',
              {},
              'empresas/list/idEmpresa/' + this.formCadastro.idEmpresa,
            )
            .then((res) => {
              Object.keys(this.formCadastro).forEach((element) => {
                if (element == 'diasVencimento') {
                  this.formCadastro.diasVencimento =
                    res.data[0][element].split(',');
                } else if (element == 'carregamentos') {
                  for (let carregamento of res.data[0].carregamentos) {
                    this.formCadastro.carregamentos[carregamento.label] =
                      carregamento;
                  }
                } else {
                  this.formCadastro[element] = res.data[0][element];
                }
              });

              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } catch (error) {}
      }
    },
    startImageResize() {
      this.carregando = true;
    },
    endImageResize() {
      this.carregando = false;
    },
    keymonitor: function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    setImage: function (output) {
      this.necessitaUpload = true;
      this.hasImage = true;
      this.image = output;
      this.imgUrl = output.dataUrl;
      this.styleFoto = 'display:none';
    },
    async onSubmit() {
      console.log('Submitting form...');
      const notValidSystemNotice =
        this.$refs.formSystemNotice && !this.$refs.formSystemNotice.validate();
      if (notValidSystemNotice) {
        return;
      }

      const valid = await this.$validator.validateAll();
      if (!valid) {
        notify.notifyFail(
          this.$vs,
          'Por favor, preencha os campos obrigatórios.',
        );
        return;
      }

      try {
        this.aguardeCadastro = true;
        await service.put('Empresa', 'Atualizar', this.formCadastro);
        notify.notifySuccess(this.$vs, 'Dados Atualizados com sucesso');
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível atualizar os Dados');
      } finally {
        this.aguardeCadastro = false;
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.formCadastro = {
        nome: '',
        email: '',
        cnpj: '',
        telefone: '',
        telefoneAssistencia: '',
        logo: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        razaoSocial: '',
        habilitarFotoGaleria: null,
        qtdDiasVencimentoAvista: '',
        qtdDiasNaoPagamento: '',
        qtdDiasEnviarNotificacaoInadimplenciaBoleto: null,
        capaBoleto: null,
        permiteVariasCotacoesPorPlaca: null,
        systemNotice: {},
      };
      this.$nextTick(() => {
        this.show = true;
      });
    },
    systemNoticeObject() {
      return this.formCadastro.systemNotice;
    },
    handleUpdateSystemNotice(notice) {
      this.formCadastro.systemNotice = notice;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.buscaDadosCadastro();
  },
  components: {
    BotaoSubmit,
    vSelect,
    CarregamentosForm,
    ErrorsAlert,
    Money,
    Routines,
    FormSystemNotice,
  },
};
</script>
<style>
#fileInput {
  display: none;
}

.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
